import { render } from "./DatabaseView.vue?vue&type=template&id=ca5d8dec&scoped=true&ts=true"
import script from "./DatabaseView.vue?vue&type=script&lang=ts"
export * from "./DatabaseView.vue?vue&type=script&lang=ts"

import "./DatabaseView.vue?vue&type=style&index=0&id=ca5d8dec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca5d8dec"]])

export default __exports__